import axios from 'axios'
import {
  isLocalDevWithBackend,
  isProduction,
  isStg,
} from 'modules/app-config/environment'
import { STG_ENV } from 'modules/app-config/stg-env'

const partnerPaymentServiceClient = axios.create({
  baseURL: getUrl(),
  headers: { 'Content-Type': 'application/json' },
  timeout: 5 * 60 * 1000,
})

partnerPaymentServiceClient.interceptors.request.use(
  (config) => {
    // Fail loudly on stg until the gateway is confirmed (FE-STG-0): never let an
    // empty baseURL silently route stg payment traffic at dev/origin.
    if (isStg() && !STG_ENV.partnerPaymentServiceUrl) {
      throw new Error(
        'partner-payment-service: no stg gateway configured (FE-STG-0 / EMS-8991)'
      )
    }
    const { idToken } = JSON.parse(localStorage.getItem('admin-token') || '{}')
    if (idToken) {
      config.headers.Authorization = idToken
    }
    return config
  },
  (error) => Promise.reject(error)
)

export function getUrl() {
  switch (true) {
    case isStg():
      return STG_ENV.partnerPaymentServiceUrl
    case isProduction():
      return 'https://jp5wtfsx5d.execute-api.us-west-2.amazonaws.com/prod'
    case isLocalDevWithBackend():
      return 'http://localhost:3011'
    default:
      return 'https://0r8wy6gcfc.execute-api.us-west-2.amazonaws.com/dev'
  }
}

export default partnerPaymentServiceClient
